export enum DirectionEnum {
	TOP = 'top',
	BOTTOM = 'bottom',
	RIGHT = 'right',
	LEFT = 'left',
	TOP_LEFT = 'topLeft',
	TOP_RIGHT = 'topRight',
	BOTTOM_LEFT = 'bottomLeft',
	BOTTOM_RIGHT = 'bottomRight',
	CENTER = 'center',
}
